import React, { useEffect, useRef, useState } from 'react';
import styles from './Me.module.css';
import orlyImage from "../../images/קרן אקסלרוד תמונת תדמית לבן.png";
import ScrollReveal from 'scrollreveal';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import teamImage from "../../images/קרן והצוות.png";
import Popped from '../poppedUpWindow/Popped'; // ודא שהנתיב נכון

gsap.registerPlugin(ScrollTrigger);

const AboutMe = () => {
  const containerRef = useRef(null);
  const quoteRef = useRef(null);
  const strongTextRefs = useRef([]);
  const [isPoppedOpen, setIsPoppedOpen] = useState(false);

  useEffect(() => {
    if (containerRef.current) {
      const sr = ScrollReveal({
        duration: 1000,
        delay: 150,
        opacity: 0,
        easing: 'cubic-bezier(0.4, 0, 0.2, 1)',
        container: window.document.documentElement,
        mobile: true,
        reset: false,
        viewFactor: 0.2
      });

      sr.reveal(`.${styles.revealItem}`, {
        origin: 'bottom',
        distance: '20px',
        interval: 100
      });

      if (quoteRef.current) {
        gsap.fromTo(
          quoteRef.current,
          { opacity: 0, scale: 0.8, rotationY: 15 },
          {
            opacity: 1,
            scale: 1,
            rotationY: 0,
            duration: 1.5,
            ease: "power3.out",
            scrollTrigger: {
              trigger: quoteRef.current,
              start: "top 80%",
              end: "bottom 20%",
              toggleActions: "play none none reverse"
            }
          }
        );
      }

      strongTextRefs.current.forEach((ref, index) => {
        if (ref) {
          gsap.fromTo(
            ref,
            { opacity: 0, x: -50, scale: 0.9 },
            {
              opacity: 1,
              x: 0,
              scale: 1,
              duration: 1.2,
              ease: "power2.out",
              delay: index * 0.2,
              scrollTrigger: {
                trigger: ref,
                start: "top 85%",
                end: "bottom 15%",
                toggleActions: "play none none reverse"
              }
            }
          );
        }
      });
    }

    return () => {
      ScrollReveal().destroy();
      ScrollTrigger.getAll().forEach(trigger => trigger.kill());
    };
  }, []);

  const handleButtonClick = () => {
    setIsPoppedOpen(true);
  };

  return (
    <>
      <section ref={containerRef} className={styles.section} id="מי אנחנו">
        <div className={styles.container}>
          <div className={`${styles.imageWrapper} ${styles.revealItem}`}>
            <img src={orlyImage} alt="קרן אקסלרוד" className={styles.image} />
          </div>

          <div className={`${styles.content} ${styles.revealItem}`}>
            <h2 className={styles.mainTitle}>נעים מאוד, קרן אקסלרוד</h2>

           
            <div className={styles.quoteContainer} ref={quoteRef}>
              <p className={styles.quote}>"אני נכנסת לתמונה כדי שתוכל לעבוד על העסק ולא בתוך העסק"</p>
            </div>

            <div className={styles.textBlock}>
              <p className={styles.paragraph}>
                אני זוכרת את עצמי כבר בגיל צעיר מחפשת פתרונות. הייתי שומעת בעיה ומיד הראש שלי התחיל לעבוד. לא חיכיתי שיבקשו ממני עזרה. פשוט רציתי לסדר דברים.. <br/> כשנכנסתי לעבוד בחברת תקשורת גדולה זה קיבל מסגרת אמיתית. התחלתי כנציגת שירות, אבל מהר מאוד עברתי לניהול מוקדי שימור ומרכזי שירות. הייתי אחראית על צוותים גדולים, על לחץ, על תהליכים, על לקוחות, שירות ומכירה, גיליתי שאני שולטת בהמון משימות ותהליכים במקביל ויודעת להפוך את הכל למערכת שמתפקדת מצויין.
              </p>

            

      
              <div className={styles.divider}></div>

              <p className={styles.paragraph}>
                עד שיום אחד חברה מהתחום אמרה לי משפט שהפך לי את הכיוון: "את מנהלת מערכות ענק. למה שלא נעזור לכל בעלי העסקים שעובדים לבד ולא מצליחים להשתלט על הכל?" זה היה רגע שהדליק לי ניצוץ. <br/>  הבנתי מה אני באמת רוצה לעשות. לא לפתור עוד תקלה נקודתית. לא להרגיע לחץ של חבר. אלא לתת לבעל עסק שפועל לבד את מה שהוא הכי זקוק לו. ניהול. סדר. תפעול. יד ימין שמחזיקה איתו את העסק
              </p>

       

              <div className={styles.divider}></div>

              <p className={styles.paragraph}>
                הקמנו משרד, ובמשך עשור שלם ליוויתי אלפי לקוחות מרוצים. בניתי מערכות, סידרתי תהליכים, והפכתי כאוס לסדר. כל לקוח היה והינו עולם ומלואו, וכל פתרון היה מותאם אישית לצרכים שלו <br/>ועכשיו, עם כל הניסיון והידע שצברתי, נולד המשרד A – מקום שבו אף בעל עסק מתרכז רק במה שחשוב!
              </p>

    

           
            </div>
          </div>     
        </div>

        {/* סקשן חדש - הצוות */}
        <div className={`${styles.teamSection} ${styles.revealItem}`}>
          <div className={styles.teamContent}>
            <h3 className={styles.teamTitle}>יחד עם הצוות המטורף שלי נדאג לכל מה שבעל עסק צריך</h3>
            
            <div className={styles.teamImageWrapper}>
              <img src={teamImage} alt="הצוות של המשרד A" className={styles.teamImage} />
            </div>
            
            <div className={styles.tagsContainer}>
              <span className={styles.tag}>ניהול אדמיניסטרציה</span>
              <span className={styles.tag}>גביה ומעקב לקוחות</span>
              <span className={styles.tag}>ארגון ותפעול</span>
              <span className={styles.tag}>פיתוח עסקי</span>
              <span className={styles.tag}>מענה ושירות ללקוחות</span>
              <span className={styles.tag}>ניהול לידים</span>
            </div>

            <p className={styles.teamClosing}>
              ולעוד עשרות שירותים! <br/>
              אז אם אתה מרגיש שהעסק שלך גדל אבל אתה לא מספיק להכל, 
              אתה רוצה סוף סוף לעבוד <strong>על</strong> העסק ולא <strong>בתוך</strong> העסק ואתה רוצה הפוקוס שלך יהיה רק על הדברים החשובים באמת
            </p>

            <button className={styles.ctaButton} onClick={handleButtonClick}>
              <span className={styles.buttonIcon}>💬</span>
              בוא נדבר - אנחנו כאן בשבילך
            </button>
          </div>
        </div>
      </section>
      
      {isPoppedOpen && <Popped onClose={() => setIsPoppedOpen(false)} />}
    </>
  );
};

export default AboutMe;